import { useState } from "react";
import { faqs, siteInfo, testimonials } from "@/mocks/gossipData";

export default function HomeFaq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <>
      <section className="w-full px-4 py-14 md:px-6 md:py-20" aria-label="读者口碑">
        <div className="flex flex-col gap-3">
          <span className="text-xs font-label uppercase tracking-widest text-secondary-700">
            Reviews
          </span>
          <h2 className="font-heading text-3xl text-foreground-950 md:text-4xl">读者怎么说</h2>
          <p className="max-w-2xl text-sm text-foreground-600">
            来自通勤党、追剧爱好者与内容从业者的真实反馈，也是我们持续整理的动力。
          </p>
        </div>
        <div className="mt-8 grid grid-cols-1 gap-5 md:grid-cols-3">
          {testimonials.map((item) => (
            <figure
              key={item.name}
              className="flex h-full flex-col rounded-xl border border-background-200 bg-background-50 p-6"
            >
              <div className="flex h-8 items-center gap-0.5 text-accent-500" aria-label="五星好评">
                {[0, 1, 2, 3, 4].map((star) => (
                  <i key={star} className="ri-star-fill text-sm" aria-hidden="true" />
                ))}
              </div>
              <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-foreground-700">
                {item.text}
              </blockquote>
              <figcaption className="mt-5 flex items-center gap-3 border-t border-background-200 pt-4">
                <span className="flex h-9 w-9 items-center justify-center rounded-full bg-secondary-100 font-heading text-secondary-900">
                  {item.name.charAt(0)}
                </span>
                <span className="flex flex-col">
                  <span className="text-sm text-foreground-950">{item.name}</span>
                  <span className="text-xs text-foreground-500">{item.role}</span>
                </span>
              </figcaption>
            </figure>
          ))}
        </div>
      </section>

      <section className="w-full bg-background-100 px-4 py-14 md:px-6 md:py-20" aria-label="常见问题">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-4">
            <span className="text-xs font-label uppercase tracking-widest text-primary-600">FAQ</span>
            <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">常见问题</h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600">
              关于内容范围、更新频率与投稿方式，这里有最直接的说明。还有其他疑问，欢迎通过
              {siteInfo.email} 联系我们。
            </p>
          </div>

          <div className="flex flex-col gap-3 lg:col-span-8">
            {faqs.map((item, index) => {
              const isOpen = openIndex === index;
              return (
                <div
                  key={item.q}
                  className="overflow-hidden rounded-xl border border-background-300 bg-background-50"
                >
                  <h3>
                    <button
                      type="button"
                      onClick={() => setOpenIndex(isOpen ? null : index)}
                      aria-expanded={isOpen}
                      className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left cursor-pointer"
                    >
                      <span className="font-heading text-base text-foreground-950 md:text-lg">
                        {item.q}
                      </span>
                      <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-background-100 text-foreground-700">
                        <i
                          className={isOpen ? "ri-subtract-line" : "ri-add-line"}
                          aria-hidden="true"
                        />
                      </span>
                    </button>
                  </h3>
                  {isOpen && (
                    <p className="border-t border-background-200 px-5 py-4 text-sm leading-relaxed text-foreground-600">
                      {item.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}